import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import EditStudent from "../components/structureComponent/editStudentComponent";

export default function EditStudentPage() {
    return (
        <Layout>
            <Header/>
            <EditStudent/>
            <Footer/>
        </Layout>
    );
};